import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { getMinCreditScore, getMinCreditScoreDictionary, getMinCreditScoreTypesForTooltip } from '@nerdwallet/marketplace/selectors/mortgages';
import { MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS, MORTGAGES_LOAN_PRODUCT_LABELS as LEGACY_LOAN_PRODUCT_LABELS, MORTGAGES_LOAN_TYPE_LABELS as LEGACY_LOAN_TYPE_LABELS } from '@nerdwallet/marketplace/constants';
import { Type } from '@nerdwallet/currency';

/**
 * Preserve exports for backwards compatibility.
 * @deprecated - Leverage exports from `@nerdwallet/marketplace/drivers/mortgages` directly.
 */
export { getDriverLoanTypesAndProducts as getQuickFactLoanTypesAndProducts, getDriverMaxLtv as getQuickFactMaxLtv, getDriverMinDownPayment as getQuickFactMinDownPayment, getDriverNationalRegional as getQuickFactNationalRegional } from '@nerdwallet/marketplace/drivers/mortgages';

/**
 * Label map that works for both the Lender Post & Marketplace data models.
 */
var MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS = _objectSpread(_objectSpread(_objectSpread({}, MORTGAGES_FEATURED_LOAN_ATTRIBUTES_TO_LABELS), LEGACY_LOAN_PRODUCT_LABELS), LEGACY_LOAN_TYPE_LABELS);

/**
 * @todo - Create Structured Content compatible tooltip and backport into `@nerdwallet/marketplace/drivers/mortgages`.
 * @see {@link https://nerdwallet.atlassian.net/browse/RUR-171}
 */
export var getQuickFactMinCreditScore = function getQuickFactMinCreditScore(lender) {
  var _ref, _get2;
  var forcedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var minCreditScoreObject = getMinCreditScoreDictionary(lender);
  var minCreditScore = (_ref = (_get2 = _get(minCreditScoreObject, forcedType)) !== null && _get2 !== void 0 ? _get2 :
  /**
   * Hack to coerce forced type to accomodate canonical enums
   */
  _get(minCreditScoreObject, forcedType === null || forcedType === void 0 ? void 0 : forcedType.toUpperCase())) !== null && _ref !== void 0 ? _ref : getMinCreditScore(lender);
  var creditScoreTypes = getMinCreditScoreTypesForTooltip(lender);
  var valueTooltip = creditScoreTypes && !_isEmpty(creditScoreTypes) ? creditScoreTypes.map(function (type) {
    var label = MIN_CREDIT_SCORE_TOOLTIP_TYPES_AND_LABELS[type];
    if (!label) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: type,
      className: classes(['display-flex', 'justify-content-space-between'])
    }, /*#__PURE__*/React.createElement(Type, {
      className: classes(['margin-right-1', 'nowrap']),
      light: true
    }, label, ":"), /*#__PURE__*/React.createElement(Type, {
      className: classes('nowrap'),
      color: "neutral-darkest"
    }, _get(minCreditScoreObject, type)));
  }) : null;
  return {
    id: 'minCreditScore',
    label: 'Min. Credit Score',
    value: minCreditScore,
    valueTooltip: valueTooltip
  };
};